export var Platforms;
(function (Platforms) {
    Platforms["desktopWEB"] = "desktopWEB";
    Platforms["desktopPWA"] = "desktopPWA";
    Platforms["tabletWEB"] = "tabletWEB";
    Platforms["tabletPWA"] = "tabletPWA";
})(Platforms || (Platforms = {}));
export const desktopPlatforms = ['desktopPWA', 'desktopWEB'];
export const mobilePlatforms = ['tabletPWA', 'tabletWEB'];
//# sourceMappingURL=Platform.js.map